import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  constructor(private http: HttpClient) {}
  addContact(body) {
    return this.http.post<ApiResponseModel>('api/contact', body);
  }
  getContactById(id) {
    return this.http.get<ApiResponseModel>('/api/contact/' + id);
  }
  editContact(body, id) {
    return this.http.patch<ApiResponseModel>('/api/contact/' + id, body);
  }

}
